'use client';

function handleInputType(typeProp = "text") {
  let props = { type: typeProp };
  if (typeProp === "number") {
    props = { type: "text", inputMode: "numeric", pattern: "[0-9]*" };
  }
  return props;
}
export {
  handleInputType
};
